import React, { Component } from 'react';
import './App.css';
import Routes from './routes.js';
import HeaderBar from './header/header';
import ScrollToBottom from './shared-components/scroll-bottom';


class App extends Component {
  render() {
    return (
      <div>
        <HeaderBar />               
        <Routes />
        <ScrollToBottom / >
      </div>
    )
  }
}

export default App;
